/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-pages.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/utils.service';
import * as import9 from '../shared/config.service';
import * as import10 from '../shared/content.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '@angular/common/src/location/location';
import * as import13 from '@angular/router/src/router';
import * as import14 from '@angular/core/src/metadata/view';
import * as import15 from '@angular/core/src/linker/component_factory';
import * as import16 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import17 from '@angular/common/src/pipes/date_pipe';
import * as import18 from '@angular/core/src/linker/template_ref';
import * as import19 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import20 from '@angular/core/src/i18n/tokens';
import * as import21 from '@angular/common/src/directives/ng_for';
import * as import22 from '@angular/core/src/security';
export class Wrapper_ContentPagesComponent {
  context:import0.ContentPagesComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.ContentPagesComponent(p0,p1,p2,p3,p4,p5);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentPagesComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentPagesComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentPagesComponent_0_4:Wrapper_ContentPagesComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPagesComponent_Host0,renderType_ContentPagesComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentPagesComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentPagesComponent_0_4 = new Wrapper_ContentPagesComponent(this.parentInjector.get(import8.UtilsService),this.parentInjector.get(import9.ConfigService),this.parentInjector.get(import10.ContentService),this.parentInjector.get(import11.ActivatedRoute),this.parentInjector.get(import12.Location),this.parentInjector.get(import13.Router));
    this._appEl_0.initComponent(this._ContentPagesComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentPagesComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentPagesComponent) && (0 === requestNodeIndex))) { return this._ContentPagesComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentPagesComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentPagesComponent_0_4.context.ngAfterContentChecked(); }
    this._ContentPagesComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPagesComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentPagesComponent_Host === (null as any))) { (renderType_ContentPagesComponent_Host = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentPagesComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentPagesComponentNgFactory:import15.ComponentFactory<import0.ContentPagesComponent> = new import15.ComponentFactory<import0.ContentPagesComponent>('ng-component',viewFactory_ContentPagesComponent_Host0,import0.ContentPagesComponent);
const styles_ContentPagesComponent:any[] = ([] as any[]);
var renderType_ContentPagesComponent:import2.RenderComponentType = (null as any);
class _View_ContentPagesComponent0 extends import1.AppView<import0.ContentPagesComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _anchor_45:any;
  /*private*/ _appEl_45:import3.AppElement;
  _TemplateRef_45_5:any;
  _NgFor_45_6:import16.Wrapper_NgFor;
  _text_46:any;
  _text_47:any;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  /*private*/ _expr_56:any;
  _pipe_date_0:import17.DatePipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPagesComponent0,renderType_ContentPagesComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_56 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'h1',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Pages\n    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','lLink'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n      ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','btn btn-default btn-sm'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'Nouveau',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_11 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n  ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_12,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n  ',(null as any));
    this._el_16 = import4.createRenderElement(this.renderer,this._el_14,'div',new import4.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n  ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_16,'div',new import4.InlineArray2(2,'class','box'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n    ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_18,'div',new import4.InlineArray2(2,'class','box-body'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n\n      ',(null as any));
    this._el_22 = import4.createRenderElement(this.renderer,this._el_20,'table',new import4.InlineArray2(2,'class','table table-striped table-hover'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._el_24 = import4.createRenderElement(this.renderer,this._el_22,'thead',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n          ',(null as any));
    this._el_26 = import4.createRenderElement(this.renderer,this._el_24,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._text_28 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_29 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'Date',(null as any));
    this._text_31 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_32 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'',(null as any));
    this._text_34 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_35 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'URL',(null as any));
    this._text_37 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._el_38 = import4.createRenderElement(this.renderer,this._el_26,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'Modifié',(null as any));
    this._text_40 = this.renderer.createText(this._el_26,'\n          ',(null as any));
    this._text_41 = this.renderer.createText(this._el_24,'\n        ',(null as any));
    this._text_42 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._el_43 = import4.createRenderElement(this.renderer,this._el_22,'tbody',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n          ',(null as any));
    this._anchor_45 = this.renderer.createTemplateAnchor(this._el_43,(null as any));
    this._appEl_45 = new import3.AppElement(45,43,this,this._anchor_45);
    this._TemplateRef_45_5 = new import18.TemplateRef_(this._appEl_45,viewFactory_ContentPagesComponent1);
    this._NgFor_45_6 = new import16.Wrapper_NgFor(this._appEl_45.vcRef,this._TemplateRef_45_5,this.parentInjector.get(import19.IterableDiffers),this.ref);
    this._text_46 = this.renderer.createText(this._el_43,'\n        ',(null as any));
    this._text_47 = this.renderer.createText(this._el_22,'\n      ',(null as any));
    this._text_48 = this.renderer.createText(this._el_20,'\n\n\n    ',(null as any));
    this._text_49 = this.renderer.createText(this._el_18,'\n  ',(null as any));
    this._text_50 = this.renderer.createText(this._el_16,'\n  ',(null as any));
    this._text_51 = this.renderer.createText(this._el_14,'\n  ',(null as any));
    this._text_52 = this.renderer.createText(this._el_12,'\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    this._pipe_date_0 = new import17.DatePipe(this.parentInjector.get(import20.LOCALE_ID));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._anchor_45,
      this._text_46,
      this._text_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.TemplateRef) && (45 === requestNodeIndex))) { return this._TemplateRef_45_5; }
    if (((token === import21.NgFor) && (45 === requestNodeIndex))) { return this._NgFor_45_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_45_0_0:any = this.context.contents;
    this._NgFor_45_6.check_ngForOf(currVal_45_0_0,throwOnChange,false);
    this._NgFor_45_6.detectChangesInInputProps(this,this._anchor_45,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_56:any = import4.interpolate(1,'Titre (',this.context.currentLanguage,')');
    if (import4.checkBinding(throwOnChange,this._expr_56,currVal_56)) {
      this.renderer.setText(this._text_33,currVal_56);
      this._expr_56 = currVal_56;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.context.utils.lLink('admin/page/edit/0',this.context.currentLanguage)) !== false);
    return (true && pd_4_0);
  }
}
export function viewFactory_ContentPagesComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentPagesComponent> {
  if ((renderType_ContentPagesComponent === (null as any))) { (renderType_ContentPagesComponent = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,styles_ContentPagesComponent,{})); }
  return new _View_ContentPagesComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPagesComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  /*private*/ _expr_16:any;
  _pipe_date_0_0:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  _pipe_date_0_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPagesComponent1,renderType_ContentPagesComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_16 = import7.UNINITIALIZED;
    this._expr_18 = import7.UNINITIALIZED;
    this._expr_19 = import7.UNINITIALIZED;
    this._expr_20 = import7.UNINITIALIZED;
    this._expr_21 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_9,'a',new import4.InlineArray4(4,'class','pointer','target','_blank'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._pipe_date_0_0 = import4.pureProxy2((<_View_ContentPagesComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentPagesComponent0>this.parent)._pipe_date_0));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    this._pipe_date_0_1 = import4.pureProxy2((<_View_ContentPagesComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentPagesComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_16:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0,(<_View_ContentPagesComponent0>this.parent)._pipe_date_0.transform)(this.context.$implicit.date,'MMM dd yyyy')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_16,currVal_16))) {
      this.renderer.setText(this._text_4,currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_18:any = import4.interpolate(1,'',(this.context.$implicit.title? this.context.$implicit.title[this.parent.context.currentLanguage]: '-'),'');
    if (import4.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setText(this._text_7,currVal_18);
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = import4.interpolate(1,'page/',this.context.$implicit.url,'');
    if (import4.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementProperty(this._el_10,'href',this.viewUtils.sanitizer.sanitize(import22.SecurityContext.URL,currVal_19));
      this._expr_19 = currVal_19;
    }
    const currVal_20:any = import4.interpolate(1,'',this.context.$implicit.url,'');
    if (import4.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setText(this._text_11,currVal_20);
      this._expr_20 = currVal_20;
    }
    valUnwrapper.reset();
    const currVal_21:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_1,(<_View_ContentPagesComponent0>this.parent)._pipe_date_0.transform)(this.context.$implicit.update_date,'MMM dd yyyy')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_21,currVal_21))) {
      this.renderer.setText(this._text_14,currVal_21);
      this._expr_21 = currVal_21;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.context.router.navigate([('page/edit/' + this.context.$implicit._id)],{relativeTo: this.parent.context.route.parent})) !== false);
    return (true && pd_6_0);
  }
}
function viewFactory_ContentPagesComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPagesComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-pages.component.ngfactory.ts